import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";

export class MachineToMachineStructurFolderDragAndDropHandler {
  machineToMachineStructureFolderDragAndDrop(targetNode) {
    const machineStructureNodeset = getMachineStructureNodeset();

    machineStructureNodeset.machineToMachineFolderDragAndDrop(
      machineStructureNodeset,
      targetNode,
    );
  }
}
